import _ from 'lodash'
import converter from 'chinese-writing-style-converter'
import { ValidateUtil } from '@vzmi/component_ec_nodejs_util'
import { FEATURE_TITLE_INVALID_REGEX } from '@vzmi/shp_shared_compo/constants/proposal'
import { removeAngleBracket } from '@vzmi/shp_shared_compo/helpers/proposalHelpers'

const { getSanitizeFlow, filterHtml, replaceNonWordByDash } = ValidateUtil

export const normalizeAll = (...normalizers) =>
  (value = '') => _.flow(normalizers)(value)

export const warrantyPeriodAndScope = (value = '') => {
  return value.replace(/[^\u4300-\u9fff\d+.]/g, '')
}

export const removeSpaceAndTab = (value = '') => {
  return _.trim(value).replace(/\\r|\\n|\\t|\r|\n|\t/g, '')
}

/** 完全過濾掉有 xss 疑慮的內容 */
export const filterHtmlTagAndSpace = normalizeAll(
  removeSpaceAndTab,
  filterHtml,
  removeAngleBracket
)

export const filterHtmlTag = normalizeAll(
  filterHtml,
  removeAngleBracket
)

export const numberNormalizer = (value = '') => {
  return _.toString(value).replace(/[^\d]/g, '')
}

export const upperCaseNormalizer = (value = '') => _.toUpper(value)

export const bsmiNormalizer = normalizeAll(
  upperCaseNormalizer,
  filterHtmlTagAndSpace
)

export const maxLengthNormalizer = maxLeng => (value = '') => _.truncate(value, { length: maxLeng, omission: '' })

/** field-level normalize **/

/** 特殊符號 非中英數字 空格 皆轉為 `-` */
export const normalizeSeoUrl = normalizeAll(
  filterHtmlTag,
  value => converter.convert(value, 'half'),
  replaceNonWordByDash
)

export const normalizeSeoUrlWithMaxLength = maxLeng => normalizeAll(
  normalizeSeoUrl,
  maxLengthNormalizer(maxLeng)
)

/** 若是空值，輸出 defaultValue */
export const atLeast = defaultValue => (value = '') => value === '' ? defaultValue : value

/** 特色標題 僅接受全型逗號、半型逗號與空白、百分號、斜線、連字號、頓號、注音符號、注音二聲(ˊ), 三聲(ˇ), 四聲(ˋ) */
const defaultFeatureTitleSanitizeFlow = getSanitizeFlow({
  withoutHtml: true,
  withoutBreakLine: true,
  trim: true,
  fullWidthToHalfWithoutComma: true,
  additionalPostStep: (value = '') => {
    // 移除非法字元
    return value.replace(FEATURE_TITLE_INVALID_REGEX, '')
  }
})
export const normalizeFeatureTitle = normalizeAll(removeSpaceAndTab, ...defaultFeatureTitleSanitizeFlow)
